import axios from 'axios';
import secrets from  "./secrets";


const GET_BUCKET_URL='https://storage.googleapis.com/storage/v1/b/jp-blog-bbb8e.appspot.com/o';
const GENERATE_TOKEN_URL='https://accounts.google.com/o/oauth2/token';


async function getAccessToken(){
    const body={
        client_secret:secrets.FIREBASE_CLIENT_SECRET,
        client_id:secrets.FIREBASE_CLIENT_ID,
        refresh_token:secrets.FIREBASE_REFRESH_TOKEN,
        grant_type:'refresh_token'
    }
    try{
        //Try to fetch locally stored token
        const storedToken=localStorage.getItem('token');
        const tokenExpiresInMilliseconds=localStorage.getItem('tokenExpiresInMilliseconds');
        if (storedToken && tokenExpiresInMilliseconds && Date.now()<tokenExpiresInMilliseconds)
            return storedToken;
        
        //Generate new token
        const {data:{access_token:newAccessToken,expires_in:expiresInSeconds}}=await axios.post(GENERATE_TOKEN_URL,body);
        localStorage.setItem('token',newAccessToken);
        localStorage.setItem('tokenExpiresInMilliseconds',Date.now()+expiresInSeconds*1000);
        return newAccessToken;
    }
    catch(err){
        console.log(err.message+' while trying to get token')
    }
}
async function getBase64Image({imageURL,imageType}){
    try{
        const {data:rawImage}=await axios.get(imageURL,{
            headers:{
                'Authorization':'Bearer '+await getAccessToken()
            },
            responseType: 'arraybuffer'
        })
        const base64EncodedImage = Buffer.from(rawImage, 'binary').toString('base64');
        const base64ImagePrefix=`data:image/${imageType};base64,`;
        return base64ImagePrefix+base64EncodedImage;
    }
    catch(err){
        console.log(`${err} while getting base64Image`)
    }
}
export async function getImages(folderPath){
    try{
        folderPath=folderPath.toLowerCase();
        const {data:{items:imagesData}}=await axios.get(GET_BUCKET_URL,{headers:{
            'Authorization':'Bearer '+await getAccessToken()
        }})
        const imagesPaths=await Promise.all
            (imagesData
                .filter(({name,contentType})=>{
                    const isImage=contentType.includes('image');
                    const isBelongingToCorrespondingFolder=name.includes(folderPath)
                    return isImage && isBelongingToCorrespondingFolder;
            })
                .map(async ({mediaLink:imageURL,contentType})=>{
                    const imageType=contentType.slice(contentType.indexOf('/') + 1); //for eg jpeg
                    const base64ImageURI= await getBase64Image({imageURL,imageType});
                    return base64ImageURI;
                }))
        if (imagesPaths.length===0)
            console.warn(`no images found for ${folderPath}!`);
        return imagesPaths;
    }
    catch(err){
        console.log(err.message+' while getting images in '+folderPath);
    }
}
getImages('hobbies/having fun');